import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import About from './About';
import Features from './Features';
import HelpTOC from './HelpTOC';
import Interpretation from './Interpretation';
import Practitioners from './Practitioners';
import Views from './Views';

function Help() {
  const { t } = useTranslation('help');
  return (
    <main id="instructions" className="textPage">
      {/* Product name is for MDR, annex I, clause 23.4, subclause a) (23.2 (a)). */}
      <h1>{t('Sensotrend Dashboard')}</h1>
      <HelpTOC />
      <Switch>
        <Route path="/help/about" component={About} />
        <Route path="/help/views" component={Views} />
        <Route path="/help/features" component={Features} />
        <Route path="/help/interpretation" component={Interpretation} />
        <Route path="/help/practitioner" component={Practitioners} />
        <Redirect to="/help/about" />
      </Switch>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2022-02-22</small>
      </footer>
    </main>
  );
}

export default Help;
